/* eslint-disable no-unused-expressions */
import React from 'react';
import ModalFormComp from '../ModalFormComp';
import './ViewFile.scss';
import FileSvg from '../../svgs/FileSvg';
import PdfViewer from './PdfViewer';
// import RefreshingSticker from '../RefreshingSticker';
import GifLoader from '../Loading/GifLoader';

interface IViewFilePlain{
  file?:any;
  fileType?:any;
  handleClose?:any;
  payload?:any;
  docName?:any;
  loading?:boolean;
  documentUrl?: string;
}
const ViewFilePlain = ({
  file,
  fileType,
  handleClose,
  loading,
  docName,
  documentUrl,
}:IViewFilePlain) => {
  const [downloading, setDownloading] = React.useState(false);
  const downloadDoc = async (imgUrl: string, fileName) => {
    try {
      const result = await fetch(imgUrl);
      const blob = await result.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
    } catch (error) {
      window.open(imgUrl, '_blank');
    }
  };

  const download = async (url: any) => {
    if (!url) return;
    const fileName = `${docName || 'file'}_${Date.now()}`;
    // Creating an anchor(a) tag of HTML
    await downloadDoc(url, fileName);
  };

  const handleDownload = async () => {
    setDownloading(true);
    await download(documentUrl);
    setDownloading(false);
  };

  return (
    <div>
      <ModalFormComp removeTitle closeModal={handleClose} modalType="file-viewer" cancleDivWidth="520px">
        <div>
          <div style={{
            height: 'fit-content', overflow: 'auto', display: 'flex', justifyContent: 'center', position: 'relative',
          }}
          >

            {loading ? <div className="loader-div"><GifLoader /></div> : (
              <div className="file-cover">

                {
                  fileType === 'image' ? <img style={{ marginBottom: '16px' }} src={file} alt="file" /> : fileType === 'pdf' ? <PdfViewer src={file} /> : <div className="svg-cover flexed-center"><FileSvg /></div>
                }
              </div>
            )}
          </div>
          <span className="doc-name">
            {docName?.toLowerCase()}
          </span>
          <span onClick={handleDownload} className="download-btn">
            {downloading ? 'Downloading...' : 'Download'}
          </span>
        </div>

      </ModalFormComp>
    </div>
  );
};
export default ViewFilePlain;
